module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w3-container about-container"
  }, [_c('h1', {
    staticClass: "w3-xxxlarge"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('About us')))])]), _vm._v(" "), _c('hr', {
    staticClass: "w3-round"
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('About us text'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "about-images-container"
  }, _vm._l((_vm.aboutImageNames), function(imageName) {
    return _c('div', [_c('img', {
      attrs: {
        "src": ("static/images/about_images/" + imageName)
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bb6ff8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutContent.vue
// module id = 952
// module chunks = 0